export const RTK_CACHE_LIFE = 900;
